import React from 'react';
import { Container, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ConstructionIcon from '@mui/icons-material/Construction';
import HeaderEntreprise from '../header/headerEntreprise';
import HeaderRec from '../header/headerRec';
import Sidebar from '../Admin/Sidebar/Sidebar';
import labels from './Labels/AddTalentModalLabel';
import './PageMaintenance.css';
import Header from '../header/header';

const PageMaintenance = ({ isForbidden = false }) => {
  const rawRole = localStorage.getItem('userType') || 'invité';
  const role = rawRole.toLowerCase();

  const renderHeader = () => {
    switch (role) {
      case 'entreprise':
        return <HeaderEntreprise />;
      case 'recruteur':
        return <HeaderRec />;
      case 'invité':
        return <Header />;
      case 'admin':
      case 'commercial':
      case 'agent':
        return (<Sidebar activeItem="" setActiveItem={() => {}} mobileOpen={false} handleDrawerToggle={() => {}}/>);
      default:
        return null;
    }
  };

  const icon = isForbidden ? (
    <BlockIcon className="access-icon forbidden" sx={{ fontSize: 120 }} />
  ) : (
    <ConstructionIcon className="access-icon maintenance" sx={{ fontSize: 120 }} />
  );

  const title = isForbidden ? labels.accessDenied.title : labels.pageMaintenance.title;
  const message = isForbidden ? labels.accessDenied.message : labels.pageMaintenance.message;

  return (
    <>
      {renderHeader()}
      <Container className="page-maintenance-wrapper">
        {icon}
        <Typography variant="h4" className="access-title">
          {title}
        </Typography>
        <Typography variant="body1" className="access-message">
          {message}
        </Typography>
      </Container>
    </>
  );
};

export default PageMaintenance;
